import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import createSagaMiddleware from "redux-saga";
import storage from "redux-persist/lib/storage";
import { createLogger } from 'redux-logger';
import { rootSaga, rootReducer } from "./ducks";

const sagaMiddleware = createSagaMiddleware();

const logger = createLogger({
  collapsed: true
});

const configureStore = () => {
  const persistConfig = {
    key: "root",
    storage,
    blacklist: ["hasTwitter", "twitter", "comments"],
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = createStore(
    persistedReducer,
    applyMiddleware(sagaMiddleware, logger)
  );
  const persistor = persistStore(store);

  sagaMiddleware.run(rootSaga);

  return { store, persistor };
};

export default configureStore;
